export enum EmailSubject {
  "Register" = 1,
  "Forgot" = 2,
}
